<div  role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Team</h2>
      </div>
      <div class="modal-body">
        <form #taskForm="ngForm">
          <div class="row">
            <div class="col-md-12">
              <div class="row" *ngIf="data.id">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="active">Set To Archieved</label>
                    <select name="active" id="active" class="form-control" [(ngModel)]="solicitor.active" required>
                        <option value="0">Yes</option>
                        <option value="1">No</option>
                    </select>
                </div>
                </div>
                <div class="field-separator"></div>
              </div>
              <div class="row">
                  <div class="col-md-2">
                    <div class="form-group">
                        <label for="title">Title</label>
                        <select name="titleId" id="titleId" class="form-control" [(ngModel)]="solicitor.titleId" required>
                          <option *ngFor="let title of titles" value="{{title.id}}">{{title.name}}</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                        <label for="title">First Name</label>
                        <input class="form-control" name="fname" id="fname"  placeholder="First Name" [(ngModel)]="solicitor.fname" required>
                      </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                        <label for="title">Last Name</label>
                        <input class="form-control" name="lname" id="lname"  placeholder="Last Name" [(ngModel)]="solicitor.lname" required>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                        <label for="title">Email</label>
                        <input class="form-control" name="email" id="email"  placeholder="Email" [(ngModel)]="solicitor.email" required>
                      </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                        <label for="emailTwo">Email 2</label>
                        <input class="form-control" name="emailTwo" id="emailTwo"  placeholder="Email Two" [(ngModel)]="solicitor.emailTwo" required>
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="title">Telephone</label>
                    <input class="form-control" name="telephone" id="telephone"  placeholder="Telephone" [(ngModel)]="solicitor.telephone" required>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="directTelephone">Direct Telephone</label>
                    <input class="form-control" name="directTelephone" id="directTelephone"  placeholder="Direct Telephone" [(ngModel)]="solicitor.directTelephone" required>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="mobile">Mobile</label>
                    <input class="form-control" name="mobile" id="mobile"  placeholder="Mobile" [(ngModel)]="solicitor.mobile" required>
                  </div>
                </div>
              </div>
              <div class="form-group">
                  <label for="notes">Notes</label>
                  <textarea class="form-control" name="note" id="note" rows="5" placeholder="Notes" [(ngModel)]="solicitor.note"></textarea>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="advancePayment">Advance Payment</label>
                    <select name="advancePayment" id="advancePayment" class="form-control" ngModel placeholder="Payment Required">
                      <option value="0">Not Required</option>
                      <option value="1">Required</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="saveTeam(taskForm.value)" [disabled]="taskForm.invalid">Save Team</button>
          <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>